// extracted by mini-css-extract-plugin
export default {"container":"oo-z","bubbleNav":"po-z","graphic":"qo-z","contact":"ro-z"};